(function () {
  var swiperInstance = null;

  function initSwiper() {
    if (window.innerWidth > 768) return;
    if (swiperInstance) return;

    swiperInstance = new Swiper('.blog__swiper', {
      slidesPerView: 1.15,
      spaceBetween: 12,
      grabCursor: true,
      pagination: {
        el: '.blog__pagination',
        clickable: true,
      },
      breakpoints: {
        480: { slidesPerView: 1.5 },
        640: { slidesPerView: 2.15 },
      },
    });
  }

  function handleResize() {
    if (window.innerWidth > 768) {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    } else {
      initSwiper();
    }
  }

  document.addEventListener('DOMContentLoaded', initSwiper);
  window.addEventListener('resize', handleResize);
})();